module.exports = __webpack_public_path__ + "assets/icon_arrow_down.3fad2e79.svg";